import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import InputBase from '@mui/material/InputBase';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import { useEffect, useState } from 'react';

const Search = styled('div')(({ theme, sx }) => ({
  display: 'flex',
  flexDirection: 'row',
  border: '1px solid #D0D0D0',
  borderRadius: '4px',
  backgroundColor: 'white',
  marginLeft: 0,
  height: '40px',
  width: '160px',
  boxShadow: '0px 2px 10px rgba(0,0,0,0.08)',
  marginRight: '12px',
  ...sx,
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '8px',
}));

const SearchAppBar = ({
  onSearch,
  value,
  placeholder,
  onBlur,
  searchIcon,
  addDebounce = true,
  sx = {},
  setOffset,
  transformInput,
}) => {
  const [inputValue, setInputValue] = useState(value);
  let searchTimer = undefined;

  useEffect(() => {
    setInputValue(value ?? '');
  }, [value]);

  const handleClear = () => {
    typeof setOffset === 'function' && setOffset(0)
    setInputValue('');
    onSearch('');
  };

  const onKeyDown = event => {
    const {
      target: { value },
      keyCode,
    } = event;
    if (keyCode === 13) {
      clearTimeout(searchTimer);
      onSearch(inputValue);
      clearInterval(searchTimer);
      typeof setOffset === 'function' && setOffset(0)
    }
  };

  const handleChange = e => {
    const val = transformInput ? transformInput(e.target.value) : e.target.value;
    setInputValue(val);

    if (addDebounce) {
      if (searchTimer) {
        clearTimeout(searchTimer);
      }
      searchTimer = setTimeout(() => {
        typeof setOffset === 'function' && setOffset(0)
        onSearch(val);
      }, 3000);
    } else {
      onSearch(val);
    }
  };

  return (
    <Box>
      <Search sx={sx}>
        <SearchIconWrapper>
          {searchIcon ? searchIcon : <SearchIcon />}
        </SearchIconWrapper>
        <InputBase
          sx={{ width: '100%' }}
          placeholder={placeholder ?? 'Search Here'}
          value={inputValue}
          onBlur={onBlur}
          inputProps={{ 'aria-label': 'search' }}
          onChange={handleChange}
          onKeyDown={onKeyDown}
        />
        {inputValue && (
          <SearchIconWrapper>
            <CloseIcon onClick={handleClear} sx={{ cursor: 'pointer' }} />
          </SearchIconWrapper>
        )}
      </Search>
    </Box>
  );
};

export default SearchAppBar;
